<template>
    <ob1-expanding-accordion
        class="bg-gray2 px-1"
        with-icon
        :icon-name="'icon-rewards'"
        :link-title="advantagesLabel"
        :link-id="'refunds-button'"
        :collapsed-block-id="'refunds-detail'"
    >
        <ul class="list-unstyled ms-1 mb-0">
            <template v-if="recovery">
                <li class="row mb-1">
                    <span class="col-12 col-md-8 ps-0">
                        <ob1-liens
                            class="p-0 text-start"
                            is-button
                            :modal-id="recoveryModalId"
                            data-bs-toggle="modal"
                            :text="recovery.label"
                            data-oevent-label="vers_popin_reprise"
                            data-oevent-category="valeur_reprise_encart_avantages"
                            data-oevent-action="en_savoir_plus_sur_la_reprise_avec_ou_sans_bonus"
                        />
                    </span>
                    <span class="col-12 col-md-4 ps-0 fw-bold amount text-end">
                        <span v-if="tunnelMode">
                            {{ recovery.details }}
                        </span>
                        <template v-else>
                            <ob1-liens
                                v-if="recovery.amountInCents == null"
                                class="p-0"
                                is-button
                                :modal-id="simulatorModalId"
                                data-bs-toggle="modal"
                                :text="recovery.details"
                                data-oevent-label="vers_simulateur"
                                data-oevent-category="a_estimer_depuis_la_fiche_produit"
                                data-oevent-action="j_accede_au_simulateur"
                            />
                            <ob1-liens
                                v-if="recovery.amountInCents != null && recovery.manualEstimation"
                                class="p-0"
                                is-button
                                :modal-id="simulatorResultModalId"
                                data-bs-toggle="modal"
                                :text="recovery.details"
                                data-oevent-label="vers_popin_de_restitution_du_simulateur"
                                data-oevent-category="estimation_realisee_et_enregistree"
                                :data-oevent-action="toTmsFormat(recovery.details) + '_' + toTmsFormat(recovery.deviceModel)"
                            />
                            <ob1-liens
                                v-if="recovery.recyclingUrl && !recovery.manualEstimation"
                                class="p-0"
                                is-link
                                :href="recovery.recyclingUrl"
                                :text="recovery.details"
                                data-oevent-label="recycler_votre_ancien_mobile"
                                :data-oevent-action="'0€_sur_votre_'+recoveryDeviceNameForTms"
                                data-oevent-category="reprise_mobile_avec_recyclage"
                                target="_blank"
                            />
                            <span v-if="recovery.amountInCents != null && !recovery.manualEstimation && recovery.recyclingUrl == null">
                                {{ recovery.details }}
                            </span>
                        </template>
                    </span>
                </li>

                <li v-if="recovery.bonus" class="row mb-1">
                    <span class="col-12 col-md-8 ps-0">
                        <ob1-liens
                            class="p-0 text-start"
                            is-button
                            :modal-id="recoveryModalId"
                            data-bs-toggle="modal"
                            :text="refundMessages.bonusTitle"
                            :data-oevent-label="'vers_popin_bonus_reprise'"
                            :data-oevent-category="'bonus_reprise_encart_avantages'"
                            :data-oevent-action="recovery.bonus.amountInCents/100 + '€_sur_votre_nouveau_mobile'"
                        />
                    </span>
                    <span class="col-12 col-md-4 ps-0 fw-bold amount text-end">
                        <span>{{ bonusAmountFormat }}</span>
                    </span>
                </li>
            </template>
            <li v-for="(odr, index) in odrs" :key="index" class="row mb-1">
                <odr
                    class="ps-0"
                    :modal-id="'popin-odr-' + deviceSeoId + '-' + index"
                    :odr-name="odr.name"
                    :odr-amount-in-cents="odr.amountInCents"
                    :odr-start-date="odr.dates.start"
                    :odr-end-date="odr.dates.end"
                    :odr-link="odr.link"
                    :promo-odr-messages="refundMessages.odrMessages"
                />
            </li>
            <li v-if="!isWithoutAdvantage" class="row">
                <strong class="ps-0" v-html="refundMessages.withConditionsLabel" />
            </li>
        </ul>
    </ob1-expanding-accordion>
</template>

<script>

import Odr from "./Odr.vue";
import {toTmsFormat} from "../../../common/utils/TmsUtils";

export default {
    components: {
        Odr
    },
    props: {
        deviceSeoId: {
            type: String,
            required: true
        },
        refundMessages: {
            type: Object,
            required: true
        },
        odrs: {
            type: Array,
            default() {
                return [];
            }
        },
        recovery: {
            type: Object,
            default: null
        },
        totalAmountInCents: {
            type: Number,
            required: true
        },
        bonusAmountFormat: {
            type: String,
            default: null
        },
        advantagesLabel: {
            type: String,
            required: true
        },
        simulatorModalId: {
            type: String,
            default: null
        },
        simulatorResultModalId: {
            type: String,
            default: null
        },
        recoveryModalId: {
            type: String,
            default: null
        },
        tunnelMode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isWithoutAdvantage() {
            return this.totalAmountInCents === 0;
        },
        recoveryDeviceNameForTms() {
            if (this.recovery) {
                return toTmsFormat(this.recovery.deviceModel);
            } else return null;
        }
    },
    methods: { toTmsFormat }
};
</script>

<style scoped lang="scss">

@media (min-width: 736px) {
    .amount {
        display: flex;
        justify-content: flex-end;
    }
}

</style>
